import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title: string;
  titleId?: string;
  desc?: string;
  descId?: string;
  color?: string;
  ariaHidden?: boolean;
  iconSize: 's' | 'm' | 'l' | 'inherit';
  style?: React.CSSProperties;
}
const svgContent = (
  props: React.SVGProps<SVGSVGElement>,
  title?: string,
  titleId?: string,
  desc?: string,
  descId?: string
) => (
  <svg
    {...props}
    viewBox="0 0 25 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    color="currentColor"
    role="img"
    aria-labelledby={titleId}
    aria-describedby={descId}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M22.319 4.43101L8.5 18.249C8.40709 18.3423 8.29668 18.4163 8.17509 18.4668C8.05351 18.5173 7.92315 18.5433 7.7915 18.5433C7.65985 18.5433 7.52949 18.5173 7.4079 18.4668C7.28632 18.4163 7.17591 18.3423 7.083 18.249L1.739 12.9C1.64609 12.8067 1.53568 12.7327 1.41409 12.6822C1.29251 12.6317 1.16215 12.6057 1.0305 12.6057C0.898845 12.6057 0.768487 12.6317 0.646905 12.6822C0.525322 12.7327 0.414909 12.8067 0.321999 12.9C0.228722 12.9929 0.15471 13.1033 0.104208 13.2249C0.0537066 13.3465 0.02771 13.4769 0.02771 13.6085C0.02771 13.7402 0.0537066 13.8705 0.104208 13.9921C0.15471 14.1137 0.228722 14.2241 0.321999 14.317L5.668 19.662C6.23195 20.2249 6.9962 20.5411 7.793 20.5411C8.5898 20.5411 9.35405 20.2249 9.918 19.662L23.736 5.84701C23.8291 5.75412 23.903 5.64377 23.9534 5.52228C24.0038 5.40079 24.0298 5.27054 24.0298 5.13901C24.0298 5.00747 24.0038 4.87723 23.9534 4.75574C23.903 4.63425 23.8291 4.5239 23.736 4.43101C23.6431 4.33773 23.5327 4.26372 23.4111 4.21322C23.2895 4.16272 23.1592 4.13672 23.0275 4.13672C22.8958 4.13672 22.7655 4.16272 22.6439 4.21322C22.5223 4.26372 22.4119 4.33773 22.319 4.43101Z"
      fill="currentColor"
    />
  </svg>
);
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  color,
  ...props
}: SVGRProps) => {
  const sizes = {
    s: '12px',
    m: '16px',
    l: '24px',
    inherit: 'inherit', // inherits size from parent
  };
  const size = sizes[iconSize] || 'inherit';
  const style = {
    width: size,
    height: size,
    display: 'flex',
    color: color, // Use the color prop for the icon color
  };
  return (
    <div
      style={style}
      aria-hidden={ariaHidden}
      id={descId ? descId : titleId} // Choose one ID based on what's available
      {...props}
    >
      {svgContent(props, title, titleId, desc, descId)}
    </div>
  );
};
const SvgCheck = SvgIcon;
export default SvgCheck;
